import React from 'react';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';
import { useBookingContext } from '../../hooks/use-booking-context';

interface props {
  passenger: string;
  passengerType: string;
  productPrice: number;
  referredPrice: number;
  refundPercentage: string;
  refundAmount: number;
  redemption: boolean;
}

const FlexPassengerRow: React.FC<props> = ({
  passenger,
  passengerType,
  productPrice,
  referredPrice,
  refundPercentage,
  refundAmount,
  redemption,
}) => {
  const { numberFormatter } = useBookingContext();

  return (
    <>
      <div
        id="flex-columns"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          gap: '18px',
          borderBottom: '1px solid var(--color-functional-neutral-400)',
          margin: '8px 0px 0px 18px',
          paddingBottom: '8px',
        }}
      >
        <TFFTypography color="color-functional-neutral-900" text={passenger} />
        <TFFTypography text={passengerType} extraStyle={{ textAlign: 'center' }} />
        <TFFTypography
          color="color-functional-neutral-900"
          text={numberFormatter.format(productPrice)}
          extraStyle={{ textAlign: 'end' }}
        />
        <TFFTypography
          color="color-functional-neutral-900"
          text={numberFormatter.format(referredPrice)}
          extraStyle={{ textAlign: 'end' }}
        />
        <TFFTypography
          color="color-functional-neutral-900"
          text={refundPercentage}
          extraStyle={{ whiteSpace: 'nowrap', textAlign: 'end' }}
        />

        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text={numberFormatter.format(refundAmount)}
          extraStyle={{ whiteSpace: 'nowrap', textAlign: 'end' }}
        />

        <TFFTypography
          color={`${redemption ? 'color-functional-success-600' : 'color-functional-alert-800'}`}
          text={redemption ? 'Available' : 'Redeemed'}
          extraStyle={{ textAlign: 'center', fontWeight: 700 }}
        />
      </div>
    </>
  );
};

export default FlexPassengerRow;
